/**
 * Project: xpenser-client
 * FilePath: /src/config/app/navigationOptions.ts
 * File: navigationOptions.ts
 * Created Date: Saturday, September 19th 2020, 2:35:46 am
 * Author: Craig Bojko (craig@pixelventures.co.uk)
 * -----
 * Last Modified: Sat Sep 19 2020
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2020 Pixel Ventures Ltd.
 * ------------------------------------
 */

export interface INavigationOption {
  label: string;
  icon: string;
  link: string;
}

export const Options: INavigationOption[] = [
  {
    label: 'Dashboard',
    icon: 'dashboard',
    link: '/dashboard'
  },
  {
    label: 'Receipts',
    icon: 'receipt',
    link: '/receipts'
  },
  {
    label: 'Settings',
    icon: 'settings',
    link: '/settings'
  }
]
export default Options
